// extracted by css-extract-rspack-plugin
export default {"card":"gpwf7","active":"Z2Zn9","link":"uGvsh","icon":"Mnham","input":"pX_4H","description":"qsGCK","name":"AkSho"};